/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as CleanUpRouteImport } from './routes/clean-up'
import { Route as BusinessRouteImport } from './routes/business'
import { Route as BookmarksRouteImport } from './routes/bookmarks'
import { Route as BookmarkRouteImport } from './routes/bookmark'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as ShopRouteRouteImport } from './routes/_shop/route'
import { Route as FoodGrubhubRouteRouteImport } from './routes/_food-grubhub/route'
import { Route as FlightRouteRouteImport } from './routes/_flight/route'
import { Route as AccountRouteRouteImport } from './routes/_account/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StoresIndexRouteImport } from './routes/stores/index'
import { Route as ChatIndexRouteImport } from './routes/chat/index'
import { Route as RReferralIdRouteImport } from './routes/r/$referralId'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as StoresStoreIdIndexRouteImport } from './routes/stores/$storeId/index'
import { Route as INTERNALMenuIndexRouteImport } from './routes/i-n-t-e-r-n-a-l/menu/index'
import { Route as ShopShopIndexRouteImport } from './routes/_shop/shop/index'
import { Route as ShopPaymentIndexRouteImport } from './routes/_shop/payment/index'
import { Route as ShopFlashDealsIndexRouteImport } from './routes/_shop/flash-deals/index'
import { Route as ShopChristmasSalesIndexRouteImport } from './routes/_shop/christmas-sales/index'
import { Route as ShopCartIndexRouteImport } from './routes/_shop/cart/index'
import { Route as FoodGrubhubFoodIndexRouteImport } from './routes/_food-grubhub/food/index'
import { Route as FlightFlightsIndexRouteImport } from './routes/_flight/flights/index'
import { Route as AccountRewardsIndexRouteImport } from './routes/_account/rewards/index'
import { Route as AccountProfileIndexRouteImport } from './routes/_account/profile/index'
import { Route as AccountOrdersIndexRouteImport } from './routes/_account/orders/index'
import { Route as AccountOrderIndexRouteImport } from './routes/_account/order/index'
import { Route as AccountFoodOrdersIndexRouteImport } from './routes/_account/food-orders/index'
import { Route as AccountFlightBookingsIndexRouteImport } from './routes/_account/flight-bookings/index'
import { Route as AuthSignInWithGoogleIdTokenRouteImport } from './routes/auth/sign-in-with-google/$idToken'
import { Route as FoodGrubhubFoodCartRouteImport } from './routes/_food-grubhub/food/cart'
import { Route as AccountAddressesIndexRouteRouteImport } from './routes/_account/addresses/index/route'
import { Route as ShopProductProductIdIndexRouteImport } from './routes/_shop/product/$productId/index'
import { Route as ShopCheckoutResultIndexRouteImport } from './routes/_shop/checkout/$result/index'
import { Route as FoodGrubhubRestaurantRestaurantIdIndexRouteImport } from './routes/_food-grubhub/restaurant/$restaurantId/index'
import { Route as FoodGrubhubFoodPaymentIndexRouteImport } from './routes/_food-grubhub/food/payment/index'
import { Route as FlightFlightsCheckoutIndexRouteImport } from './routes/_flight/flights/checkout/index'
import { Route as FlightFlightsFlightIdIndexRouteImport } from './routes/_flight/flights/$flightId/index'
import { Route as AccountOrdersOrderIdIndexRouteImport } from './routes/_account/orders/$orderId/index'
import { Route as AccountOrderOrderIdIndexRouteImport } from './routes/_account/order/$orderId/index'
import { Route as AccountFoodOrdersFoodOrderIdIndexRouteImport } from './routes/_account/food-orders/$foodOrderId/index'
import { Route as AccountFlightBookingsBookingIdIndexRouteImport } from './routes/_account/flight-bookings/$bookingId/index'
import { Route as FoodGrubhubFoodPaymentSuccessRouteImport } from './routes/_food-grubhub/food/payment/success'
import { Route as FoodGrubhubRestaurantRestaurantIdMenuItemMenuItemIdIndexRouteImport } from './routes/_food-grubhub/restaurant/$restaurantId/menuItem/$menuItemId/index'

const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/pricing.lazy').then((d) => d.Route))
const ContactUsRoute = ContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/contact-us.lazy').then((d) => d.Route))
const CleanUpRoute = CleanUpRouteImport.update({
  id: '/clean-up',
  path: '/clean-up',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessRoute = BusinessRouteImport.update({
  id: '/business',
  path: '/business',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/business.lazy').then((d) => d.Route))
const BookmarksRoute = BookmarksRouteImport.update({
  id: '/bookmarks',
  path: '/bookmarks',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/bookmarks.lazy').then((d) => d.Route))
const BookmarkRoute = BookmarkRouteImport.update({
  id: '/bookmark',
  path: '/bookmark',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/bookmark.lazy').then((d) => d.Route))
const AboutUsRoute = AboutUsRouteImport.update({
  id: '/about-us',
  path: '/about-us',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/about-us.lazy').then((d) => d.Route))
const ShopRouteRoute = ShopRouteRouteImport.update({
  id: '/_shop',
  getParentRoute: () => rootRouteImport,
} as any)
const FoodGrubhubRouteRoute = FoodGrubhubRouteRouteImport.update({
  id: '/_food-grubhub',
  getParentRoute: () => rootRouteImport,
} as any)
const FlightRouteRoute = FlightRouteRouteImport.update({
  id: '/_flight',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRouteRoute = AccountRouteRouteImport.update({
  id: '/_account',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/_account/route.lazy').then((d) => d.Route),
)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const StoresIndexRoute = StoresIndexRouteImport.update({
  id: '/stores/',
  path: '/stores/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/stores/index.lazy').then((d) => d.Route))
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/chat/index.lazy').then((d) => d.Route))
const RReferralIdRoute = RReferralIdRouteImport.update({
  id: '/r/$referralId',
  path: '/r/$referralId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/auth/sign-up.lazy').then((d) => d.Route))
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/auth/sign-in.lazy').then((d) => d.Route))
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/auth/reset-password.lazy').then((d) => d.Route),
)
const StoresStoreIdIndexRoute = StoresStoreIdIndexRouteImport.update({
  id: '/stores/$storeId/',
  path: '/stores/$storeId/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/stores/$storeId/index.lazy').then((d) => d.Route),
)
const INTERNALMenuIndexRoute = INTERNALMenuIndexRouteImport.update({
  id: '/i-n-t-e-r-n-a-l/menu/',
  path: '/i-n-t-e-r-n-a-l/menu/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShopShopIndexRoute = ShopShopIndexRouteImport.update({
  id: '/shop/',
  path: '/shop/',
  getParentRoute: () => ShopRouteRoute,
} as any).lazy(() =>
  import('./routes/_shop/shop/index.lazy').then((d) => d.Route),
)
const ShopPaymentIndexRoute = ShopPaymentIndexRouteImport.update({
  id: '/payment/',
  path: '/payment/',
  getParentRoute: () => ShopRouteRoute,
} as any).lazy(() =>
  import('./routes/_shop/payment/index.lazy').then((d) => d.Route),
)
const ShopFlashDealsIndexRoute = ShopFlashDealsIndexRouteImport.update({
  id: '/flash-deals/',
  path: '/flash-deals/',
  getParentRoute: () => ShopRouteRoute,
} as any).lazy(() =>
  import('./routes/_shop/flash-deals/index.lazy').then((d) => d.Route),
)
const ShopChristmasSalesIndexRoute = ShopChristmasSalesIndexRouteImport.update({
  id: '/christmas-sales/',
  path: '/christmas-sales/',
  getParentRoute: () => ShopRouteRoute,
} as any).lazy(() =>
  import('./routes/_shop/christmas-sales/index.lazy').then((d) => d.Route),
)
const ShopCartIndexRoute = ShopCartIndexRouteImport.update({
  id: '/cart/',
  path: '/cart/',
  getParentRoute: () => ShopRouteRoute,
} as any).lazy(() =>
  import('./routes/_shop/cart/index.lazy').then((d) => d.Route),
)
const FoodGrubhubFoodIndexRoute = FoodGrubhubFoodIndexRouteImport.update({
  id: '/food/',
  path: '/food/',
  getParentRoute: () => FoodGrubhubRouteRoute,
} as any).lazy(() =>
  import('./routes/_food-grubhub/food/index.lazy').then((d) => d.Route),
)
const FlightFlightsIndexRoute = FlightFlightsIndexRouteImport.update({
  id: '/flights/',
  path: '/flights/',
  getParentRoute: () => FlightRouteRoute,
} as any).lazy(() =>
  import('./routes/_flight/flights/index.lazy').then((d) => d.Route),
)
const AccountRewardsIndexRoute = AccountRewardsIndexRouteImport.update({
  id: '/rewards/',
  path: '/rewards/',
  getParentRoute: () => AccountRouteRoute,
} as any).lazy(() =>
  import('./routes/_account/rewards/index.lazy').then((d) => d.Route),
)
const AccountProfileIndexRoute = AccountProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AccountRouteRoute,
} as any).lazy(() =>
  import('./routes/_account/profile/index.lazy').then((d) => d.Route),
)
const AccountOrdersIndexRoute = AccountOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AccountRouteRoute,
} as any).lazy(() =>
  import('./routes/_account/orders/index.lazy').then((d) => d.Route),
)
const AccountOrderIndexRoute = AccountOrderIndexRouteImport.update({
  id: '/order/',
  path: '/order/',
  getParentRoute: () => AccountRouteRoute,
} as any).lazy(() =>
  import('./routes/_account/order/index.lazy').then((d) => d.Route),
)
const AccountFoodOrdersIndexRoute = AccountFoodOrdersIndexRouteImport.update({
  id: '/food-orders/',
  path: '/food-orders/',
  getParentRoute: () => AccountRouteRoute,
} as any).lazy(() =>
  import('./routes/_account/food-orders/index.lazy').then((d) => d.Route),
)
const AccountFlightBookingsIndexRoute =
  AccountFlightBookingsIndexRouteImport.update({
    id: '/flight-bookings/',
    path: '/flight-bookings/',
    getParentRoute: () => AccountRouteRoute,
  } as any).lazy(() =>
    import('./routes/_account/flight-bookings/index.lazy').then((d) => d.Route),
  )
const AuthSignInWithGoogleIdTokenRoute =
  AuthSignInWithGoogleIdTokenRouteImport.update({
    id: '/auth/sign-in-with-google/$idToken',
    path: '/auth/sign-in-with-google/$idToken',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/auth/sign-in-with-google/$idToken.lazy').then(
      (d) => d.Route,
    ),
  )
const FoodGrubhubFoodCartRoute = FoodGrubhubFoodCartRouteImport.update({
  id: '/food/cart',
  path: '/food/cart',
  getParentRoute: () => FoodGrubhubRouteRoute,
} as any).lazy(() =>
  import('./routes/_food-grubhub/food/cart.lazy').then((d) => d.Route),
)
const AccountAddressesIndexRouteRoute =
  AccountAddressesIndexRouteRouteImport.update({
    id: '/addresses/',
    path: '/addresses/',
    getParentRoute: () => AccountRouteRoute,
  } as any).lazy(() =>
    import('./routes/_account/addresses/index/route.lazy').then((d) => d.Route),
  )
const ShopProductProductIdIndexRoute =
  ShopProductProductIdIndexRouteImport.update({
    id: '/product/$productId/',
    path: '/product/$productId/',
    getParentRoute: () => ShopRouteRoute,
  } as any).lazy(() =>
    import('./routes/_shop/product/$productId/index.lazy').then((d) => d.Route),
  )
const ShopCheckoutResultIndexRoute = ShopCheckoutResultIndexRouteImport.update({
  id: '/checkout/$result/',
  path: '/checkout/$result/',
  getParentRoute: () => ShopRouteRoute,
} as any).lazy(() =>
  import('./routes/_shop/checkout/$result/index.lazy').then((d) => d.Route),
)
const FoodGrubhubRestaurantRestaurantIdIndexRoute =
  FoodGrubhubRestaurantRestaurantIdIndexRouteImport.update({
    id: '/restaurant/$restaurantId/',
    path: '/restaurant/$restaurantId/',
    getParentRoute: () => FoodGrubhubRouteRoute,
  } as any).lazy(() =>
    import('./routes/_food-grubhub/restaurant/$restaurantId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const FoodGrubhubFoodPaymentIndexRoute =
  FoodGrubhubFoodPaymentIndexRouteImport.update({
    id: '/food/payment/',
    path: '/food/payment/',
    getParentRoute: () => FoodGrubhubRouteRoute,
  } as any).lazy(() =>
    import('./routes/_food-grubhub/food/payment/index.lazy').then(
      (d) => d.Route,
    ),
  )
const FlightFlightsCheckoutIndexRoute =
  FlightFlightsCheckoutIndexRouteImport.update({
    id: '/flights/checkout/',
    path: '/flights/checkout/',
    getParentRoute: () => FlightRouteRoute,
  } as any).lazy(() =>
    import('./routes/_flight/flights/checkout/index.lazy').then((d) => d.Route),
  )
const FlightFlightsFlightIdIndexRoute =
  FlightFlightsFlightIdIndexRouteImport.update({
    id: '/flights/$flightId/',
    path: '/flights/$flightId/',
    getParentRoute: () => FlightRouteRoute,
  } as any).lazy(() =>
    import('./routes/_flight/flights/$flightId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AccountOrdersOrderIdIndexRoute =
  AccountOrdersOrderIdIndexRouteImport.update({
    id: '/orders/$orderId/',
    path: '/orders/$orderId/',
    getParentRoute: () => AccountRouteRoute,
  } as any).lazy(() =>
    import('./routes/_account/orders/$orderId/index.lazy').then((d) => d.Route),
  )
const AccountOrderOrderIdIndexRoute =
  AccountOrderOrderIdIndexRouteImport.update({
    id: '/order/$orderId/',
    path: '/order/$orderId/',
    getParentRoute: () => AccountRouteRoute,
  } as any)
const AccountFoodOrdersFoodOrderIdIndexRoute =
  AccountFoodOrdersFoodOrderIdIndexRouteImport.update({
    id: '/food-orders/$foodOrderId/',
    path: '/food-orders/$foodOrderId/',
    getParentRoute: () => AccountRouteRoute,
  } as any).lazy(() =>
    import('./routes/_account/food-orders/$foodOrderId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AccountFlightBookingsBookingIdIndexRoute =
  AccountFlightBookingsBookingIdIndexRouteImport.update({
    id: '/flight-bookings/$bookingId/',
    path: '/flight-bookings/$bookingId/',
    getParentRoute: () => AccountRouteRoute,
  } as any).lazy(() =>
    import('./routes/_account/flight-bookings/$bookingId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const FoodGrubhubFoodPaymentSuccessRoute =
  FoodGrubhubFoodPaymentSuccessRouteImport.update({
    id: '/food/payment/success',
    path: '/food/payment/success',
    getParentRoute: () => FoodGrubhubRouteRoute,
  } as any).lazy(() =>
    import('./routes/_food-grubhub/food/payment/success.lazy').then(
      (d) => d.Route,
    ),
  )
const FoodGrubhubRestaurantRestaurantIdMenuItemMenuItemIdIndexRoute =
  FoodGrubhubRestaurantRestaurantIdMenuItemMenuItemIdIndexRouteImport.update({
    id: '/restaurant/$restaurantId/menuItem/$menuItemId/',
    path: '/restaurant/$restaurantId/menuItem/$menuItemId/',
    getParentRoute: () => FoodGrubhubRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_food-grubhub/restaurant/$restaurantId/menuItem/$menuItemId/index.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about-us': typeof AboutUsRoute
  '/bookmark': typeof BookmarkRoute
  '/bookmarks': typeof BookmarksRoute
  '/business': typeof BusinessRoute
  '/clean-up': typeof CleanUpRoute
  '/contact-us': typeof ContactUsRoute
  '/pricing': typeof PricingRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/r/$referralId': typeof RReferralIdRoute
  '/chat': typeof ChatIndexRoute
  '/stores': typeof StoresIndexRoute
  '/addresses': typeof AccountAddressesIndexRouteRoute
  '/food/cart': typeof FoodGrubhubFoodCartRoute
  '/auth/sign-in-with-google/$idToken': typeof AuthSignInWithGoogleIdTokenRoute
  '/flight-bookings': typeof AccountFlightBookingsIndexRoute
  '/food-orders': typeof AccountFoodOrdersIndexRoute
  '/order': typeof AccountOrderIndexRoute
  '/orders': typeof AccountOrdersIndexRoute
  '/profile': typeof AccountProfileIndexRoute
  '/rewards': typeof AccountRewardsIndexRoute
  '/flights': typeof FlightFlightsIndexRoute
  '/food': typeof FoodGrubhubFoodIndexRoute
  '/cart': typeof ShopCartIndexRoute
  '/christmas-sales': typeof ShopChristmasSalesIndexRoute
  '/flash-deals': typeof ShopFlashDealsIndexRoute
  '/payment': typeof ShopPaymentIndexRoute
  '/shop': typeof ShopShopIndexRoute
  '/i-n-t-e-r-n-a-l/menu': typeof INTERNALMenuIndexRoute
  '/stores/$storeId': typeof StoresStoreIdIndexRoute
  '/food/payment/success': typeof FoodGrubhubFoodPaymentSuccessRoute
  '/flight-bookings/$bookingId': typeof AccountFlightBookingsBookingIdIndexRoute
  '/food-orders/$foodOrderId': typeof AccountFoodOrdersFoodOrderIdIndexRoute
  '/order/$orderId': typeof AccountOrderOrderIdIndexRoute
  '/orders/$orderId': typeof AccountOrdersOrderIdIndexRoute
  '/flights/$flightId': typeof FlightFlightsFlightIdIndexRoute
  '/flights/checkout': typeof FlightFlightsCheckoutIndexRoute
  '/food/payment': typeof FoodGrubhubFoodPaymentIndexRoute
  '/restaurant/$restaurantId': typeof FoodGrubhubRestaurantRestaurantIdIndexRoute
  '/checkout/$result': typeof ShopCheckoutResultIndexRoute
  '/product/$productId': typeof ShopProductProductIdIndexRoute
  '/restaurant/$restaurantId/menuItem/$menuItemId': typeof FoodGrubhubRestaurantRestaurantIdMenuItemMenuItemIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about-us': typeof AboutUsRoute
  '/bookmark': typeof BookmarkRoute
  '/bookmarks': typeof BookmarksRoute
  '/business': typeof BusinessRoute
  '/clean-up': typeof CleanUpRoute
  '/contact-us': typeof ContactUsRoute
  '/pricing': typeof PricingRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/r/$referralId': typeof RReferralIdRoute
  '/chat': typeof ChatIndexRoute
  '/stores': typeof StoresIndexRoute
  '/addresses': typeof AccountAddressesIndexRouteRoute
  '/food/cart': typeof FoodGrubhubFoodCartRoute
  '/auth/sign-in-with-google/$idToken': typeof AuthSignInWithGoogleIdTokenRoute
  '/flight-bookings': typeof AccountFlightBookingsIndexRoute
  '/food-orders': typeof AccountFoodOrdersIndexRoute
  '/order': typeof AccountOrderIndexRoute
  '/orders': typeof AccountOrdersIndexRoute
  '/profile': typeof AccountProfileIndexRoute
  '/rewards': typeof AccountRewardsIndexRoute
  '/flights': typeof FlightFlightsIndexRoute
  '/food': typeof FoodGrubhubFoodIndexRoute
  '/cart': typeof ShopCartIndexRoute
  '/christmas-sales': typeof ShopChristmasSalesIndexRoute
  '/flash-deals': typeof ShopFlashDealsIndexRoute
  '/payment': typeof ShopPaymentIndexRoute
  '/shop': typeof ShopShopIndexRoute
  '/i-n-t-e-r-n-a-l/menu': typeof INTERNALMenuIndexRoute
  '/stores/$storeId': typeof StoresStoreIdIndexRoute
  '/food/payment/success': typeof FoodGrubhubFoodPaymentSuccessRoute
  '/flight-bookings/$bookingId': typeof AccountFlightBookingsBookingIdIndexRoute
  '/food-orders/$foodOrderId': typeof AccountFoodOrdersFoodOrderIdIndexRoute
  '/order/$orderId': typeof AccountOrderOrderIdIndexRoute
  '/orders/$orderId': typeof AccountOrdersOrderIdIndexRoute
  '/flights/$flightId': typeof FlightFlightsFlightIdIndexRoute
  '/flights/checkout': typeof FlightFlightsCheckoutIndexRoute
  '/food/payment': typeof FoodGrubhubFoodPaymentIndexRoute
  '/restaurant/$restaurantId': typeof FoodGrubhubRestaurantRestaurantIdIndexRoute
  '/checkout/$result': typeof ShopCheckoutResultIndexRoute
  '/product/$productId': typeof ShopProductProductIdIndexRoute
  '/restaurant/$restaurantId/menuItem/$menuItemId': typeof FoodGrubhubRestaurantRestaurantIdMenuItemMenuItemIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_account': typeof AccountRouteRouteWithChildren
  '/_flight': typeof FlightRouteRouteWithChildren
  '/_food-grubhub': typeof FoodGrubhubRouteRouteWithChildren
  '/_shop': typeof ShopRouteRouteWithChildren
  '/about-us': typeof AboutUsRoute
  '/bookmark': typeof BookmarkRoute
  '/bookmarks': typeof BookmarksRoute
  '/business': typeof BusinessRoute
  '/clean-up': typeof CleanUpRoute
  '/contact-us': typeof ContactUsRoute
  '/pricing': typeof PricingRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/r/$referralId': typeof RReferralIdRoute
  '/chat/': typeof ChatIndexRoute
  '/stores/': typeof StoresIndexRoute
  '/_account/addresses/': typeof AccountAddressesIndexRouteRoute
  '/_food-grubhub/food/cart': typeof FoodGrubhubFoodCartRoute
  '/auth/sign-in-with-google/$idToken': typeof AuthSignInWithGoogleIdTokenRoute
  '/_account/flight-bookings/': typeof AccountFlightBookingsIndexRoute
  '/_account/food-orders/': typeof AccountFoodOrdersIndexRoute
  '/_account/order/': typeof AccountOrderIndexRoute
  '/_account/orders/': typeof AccountOrdersIndexRoute
  '/_account/profile/': typeof AccountProfileIndexRoute
  '/_account/rewards/': typeof AccountRewardsIndexRoute
  '/_flight/flights/': typeof FlightFlightsIndexRoute
  '/_food-grubhub/food/': typeof FoodGrubhubFoodIndexRoute
  '/_shop/cart/': typeof ShopCartIndexRoute
  '/_shop/christmas-sales/': typeof ShopChristmasSalesIndexRoute
  '/_shop/flash-deals/': typeof ShopFlashDealsIndexRoute
  '/_shop/payment/': typeof ShopPaymentIndexRoute
  '/_shop/shop/': typeof ShopShopIndexRoute
  '/i-n-t-e-r-n-a-l/menu/': typeof INTERNALMenuIndexRoute
  '/stores/$storeId/': typeof StoresStoreIdIndexRoute
  '/_food-grubhub/food/payment/success': typeof FoodGrubhubFoodPaymentSuccessRoute
  '/_account/flight-bookings/$bookingId/': typeof AccountFlightBookingsBookingIdIndexRoute
  '/_account/food-orders/$foodOrderId/': typeof AccountFoodOrdersFoodOrderIdIndexRoute
  '/_account/order/$orderId/': typeof AccountOrderOrderIdIndexRoute
  '/_account/orders/$orderId/': typeof AccountOrdersOrderIdIndexRoute
  '/_flight/flights/$flightId/': typeof FlightFlightsFlightIdIndexRoute
  '/_flight/flights/checkout/': typeof FlightFlightsCheckoutIndexRoute
  '/_food-grubhub/food/payment/': typeof FoodGrubhubFoodPaymentIndexRoute
  '/_food-grubhub/restaurant/$restaurantId/': typeof FoodGrubhubRestaurantRestaurantIdIndexRoute
  '/_shop/checkout/$result/': typeof ShopCheckoutResultIndexRoute
  '/_shop/product/$productId/': typeof ShopProductProductIdIndexRoute
  '/_food-grubhub/restaurant/$restaurantId/menuItem/$menuItemId/': typeof FoodGrubhubRestaurantRestaurantIdMenuItemMenuItemIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about-us'
    | '/bookmark'
    | '/bookmarks'
    | '/business'
    | '/clean-up'
    | '/contact-us'
    | '/pricing'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/r/$referralId'
    | '/chat'
    | '/stores'
    | '/addresses'
    | '/food/cart'
    | '/auth/sign-in-with-google/$idToken'
    | '/flight-bookings'
    | '/food-orders'
    | '/order'
    | '/orders'
    | '/profile'
    | '/rewards'
    | '/flights'
    | '/food'
    | '/cart'
    | '/christmas-sales'
    | '/flash-deals'
    | '/payment'
    | '/shop'
    | '/i-n-t-e-r-n-a-l/menu'
    | '/stores/$storeId'
    | '/food/payment/success'
    | '/flight-bookings/$bookingId'
    | '/food-orders/$foodOrderId'
    | '/order/$orderId'
    | '/orders/$orderId'
    | '/flights/$flightId'
    | '/flights/checkout'
    | '/food/payment'
    | '/restaurant/$restaurantId'
    | '/checkout/$result'
    | '/product/$productId'
    | '/restaurant/$restaurantId/menuItem/$menuItemId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about-us'
    | '/bookmark'
    | '/bookmarks'
    | '/business'
    | '/clean-up'
    | '/contact-us'
    | '/pricing'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/r/$referralId'
    | '/chat'
    | '/stores'
    | '/addresses'
    | '/food/cart'
    | '/auth/sign-in-with-google/$idToken'
    | '/flight-bookings'
    | '/food-orders'
    | '/order'
    | '/orders'
    | '/profile'
    | '/rewards'
    | '/flights'
    | '/food'
    | '/cart'
    | '/christmas-sales'
    | '/flash-deals'
    | '/payment'
    | '/shop'
    | '/i-n-t-e-r-n-a-l/menu'
    | '/stores/$storeId'
    | '/food/payment/success'
    | '/flight-bookings/$bookingId'
    | '/food-orders/$foodOrderId'
    | '/order/$orderId'
    | '/orders/$orderId'
    | '/flights/$flightId'
    | '/flights/checkout'
    | '/food/payment'
    | '/restaurant/$restaurantId'
    | '/checkout/$result'
    | '/product/$productId'
    | '/restaurant/$restaurantId/menuItem/$menuItemId'
  id:
    | '__root__'
    | '/'
    | '/_account'
    | '/_flight'
    | '/_food-grubhub'
    | '/_shop'
    | '/about-us'
    | '/bookmark'
    | '/bookmarks'
    | '/business'
    | '/clean-up'
    | '/contact-us'
    | '/pricing'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/r/$referralId'
    | '/chat/'
    | '/stores/'
    | '/_account/addresses/'
    | '/_food-grubhub/food/cart'
    | '/auth/sign-in-with-google/$idToken'
    | '/_account/flight-bookings/'
    | '/_account/food-orders/'
    | '/_account/order/'
    | '/_account/orders/'
    | '/_account/profile/'
    | '/_account/rewards/'
    | '/_flight/flights/'
    | '/_food-grubhub/food/'
    | '/_shop/cart/'
    | '/_shop/christmas-sales/'
    | '/_shop/flash-deals/'
    | '/_shop/payment/'
    | '/_shop/shop/'
    | '/i-n-t-e-r-n-a-l/menu/'
    | '/stores/$storeId/'
    | '/_food-grubhub/food/payment/success'
    | '/_account/flight-bookings/$bookingId/'
    | '/_account/food-orders/$foodOrderId/'
    | '/_account/order/$orderId/'
    | '/_account/orders/$orderId/'
    | '/_flight/flights/$flightId/'
    | '/_flight/flights/checkout/'
    | '/_food-grubhub/food/payment/'
    | '/_food-grubhub/restaurant/$restaurantId/'
    | '/_shop/checkout/$result/'
    | '/_shop/product/$productId/'
    | '/_food-grubhub/restaurant/$restaurantId/menuItem/$menuItemId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRouteRoute: typeof AccountRouteRouteWithChildren
  FlightRouteRoute: typeof FlightRouteRouteWithChildren
  FoodGrubhubRouteRoute: typeof FoodGrubhubRouteRouteWithChildren
  ShopRouteRoute: typeof ShopRouteRouteWithChildren
  AboutUsRoute: typeof AboutUsRoute
  BookmarkRoute: typeof BookmarkRoute
  BookmarksRoute: typeof BookmarksRoute
  BusinessRoute: typeof BusinessRoute
  CleanUpRoute: typeof CleanUpRoute
  ContactUsRoute: typeof ContactUsRoute
  PricingRoute: typeof PricingRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  RReferralIdRoute: typeof RReferralIdRoute
  ChatIndexRoute: typeof ChatIndexRoute
  StoresIndexRoute: typeof StoresIndexRoute
  AuthSignInWithGoogleIdTokenRoute: typeof AuthSignInWithGoogleIdTokenRoute
  INTERNALMenuIndexRoute: typeof INTERNALMenuIndexRoute
  StoresStoreIdIndexRoute: typeof StoresStoreIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clean-up': {
      id: '/clean-up'
      path: '/clean-up'
      fullPath: '/clean-up'
      preLoaderRoute: typeof CleanUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business': {
      id: '/business'
      path: '/business'
      fullPath: '/business'
      preLoaderRoute: typeof BusinessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookmarks': {
      id: '/bookmarks'
      path: '/bookmarks'
      fullPath: '/bookmarks'
      preLoaderRoute: typeof BookmarksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookmark': {
      id: '/bookmark'
      path: '/bookmark'
      fullPath: '/bookmark'
      preLoaderRoute: typeof BookmarkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about-us': {
      id: '/about-us'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof AboutUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shop': {
      id: '/_shop'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ShopRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_food-grubhub': {
      id: '/_food-grubhub'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof FoodGrubhubRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_flight': {
      id: '/_flight'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof FlightRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_account': {
      id: '/_account'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AccountRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stores/': {
      id: '/stores/'
      path: '/stores'
      fullPath: '/stores'
      preLoaderRoute: typeof StoresIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/': {
      id: '/chat/'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$referralId': {
      id: '/r/$referralId'
      path: '/r/$referralId'
      fullPath: '/r/$referralId'
      preLoaderRoute: typeof RReferralIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stores/$storeId/': {
      id: '/stores/$storeId/'
      path: '/stores/$storeId'
      fullPath: '/stores/$storeId'
      preLoaderRoute: typeof StoresStoreIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/i-n-t-e-r-n-a-l/menu/': {
      id: '/i-n-t-e-r-n-a-l/menu/'
      path: '/i-n-t-e-r-n-a-l/menu'
      fullPath: '/i-n-t-e-r-n-a-l/menu'
      preLoaderRoute: typeof INTERNALMenuIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shop/shop/': {
      id: '/_shop/shop/'
      path: '/shop'
      fullPath: '/shop'
      preLoaderRoute: typeof ShopShopIndexRouteImport
      parentRoute: typeof ShopRouteRoute
    }
    '/_shop/payment/': {
      id: '/_shop/payment/'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof ShopPaymentIndexRouteImport
      parentRoute: typeof ShopRouteRoute
    }
    '/_shop/flash-deals/': {
      id: '/_shop/flash-deals/'
      path: '/flash-deals'
      fullPath: '/flash-deals'
      preLoaderRoute: typeof ShopFlashDealsIndexRouteImport
      parentRoute: typeof ShopRouteRoute
    }
    '/_shop/christmas-sales/': {
      id: '/_shop/christmas-sales/'
      path: '/christmas-sales'
      fullPath: '/christmas-sales'
      preLoaderRoute: typeof ShopChristmasSalesIndexRouteImport
      parentRoute: typeof ShopRouteRoute
    }
    '/_shop/cart/': {
      id: '/_shop/cart/'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof ShopCartIndexRouteImport
      parentRoute: typeof ShopRouteRoute
    }
    '/_food-grubhub/food/': {
      id: '/_food-grubhub/food/'
      path: '/food'
      fullPath: '/food'
      preLoaderRoute: typeof FoodGrubhubFoodIndexRouteImport
      parentRoute: typeof FoodGrubhubRouteRoute
    }
    '/_flight/flights/': {
      id: '/_flight/flights/'
      path: '/flights'
      fullPath: '/flights'
      preLoaderRoute: typeof FlightFlightsIndexRouteImport
      parentRoute: typeof FlightRouteRoute
    }
    '/_account/rewards/': {
      id: '/_account/rewards/'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof AccountRewardsIndexRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/_account/profile/': {
      id: '/_account/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AccountProfileIndexRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/_account/orders/': {
      id: '/_account/orders/'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AccountOrdersIndexRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/_account/order/': {
      id: '/_account/order/'
      path: '/order'
      fullPath: '/order'
      preLoaderRoute: typeof AccountOrderIndexRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/_account/food-orders/': {
      id: '/_account/food-orders/'
      path: '/food-orders'
      fullPath: '/food-orders'
      preLoaderRoute: typeof AccountFoodOrdersIndexRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/_account/flight-bookings/': {
      id: '/_account/flight-bookings/'
      path: '/flight-bookings'
      fullPath: '/flight-bookings'
      preLoaderRoute: typeof AccountFlightBookingsIndexRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/auth/sign-in-with-google/$idToken': {
      id: '/auth/sign-in-with-google/$idToken'
      path: '/auth/sign-in-with-google/$idToken'
      fullPath: '/auth/sign-in-with-google/$idToken'
      preLoaderRoute: typeof AuthSignInWithGoogleIdTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_food-grubhub/food/cart': {
      id: '/_food-grubhub/food/cart'
      path: '/food/cart'
      fullPath: '/food/cart'
      preLoaderRoute: typeof FoodGrubhubFoodCartRouteImport
      parentRoute: typeof FoodGrubhubRouteRoute
    }
    '/_account/addresses/': {
      id: '/_account/addresses/'
      path: '/addresses'
      fullPath: '/addresses'
      preLoaderRoute: typeof AccountAddressesIndexRouteRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/_shop/product/$productId/': {
      id: '/_shop/product/$productId/'
      path: '/product/$productId'
      fullPath: '/product/$productId'
      preLoaderRoute: typeof ShopProductProductIdIndexRouteImport
      parentRoute: typeof ShopRouteRoute
    }
    '/_shop/checkout/$result/': {
      id: '/_shop/checkout/$result/'
      path: '/checkout/$result'
      fullPath: '/checkout/$result'
      preLoaderRoute: typeof ShopCheckoutResultIndexRouteImport
      parentRoute: typeof ShopRouteRoute
    }
    '/_food-grubhub/restaurant/$restaurantId/': {
      id: '/_food-grubhub/restaurant/$restaurantId/'
      path: '/restaurant/$restaurantId'
      fullPath: '/restaurant/$restaurantId'
      preLoaderRoute: typeof FoodGrubhubRestaurantRestaurantIdIndexRouteImport
      parentRoute: typeof FoodGrubhubRouteRoute
    }
    '/_food-grubhub/food/payment/': {
      id: '/_food-grubhub/food/payment/'
      path: '/food/payment'
      fullPath: '/food/payment'
      preLoaderRoute: typeof FoodGrubhubFoodPaymentIndexRouteImport
      parentRoute: typeof FoodGrubhubRouteRoute
    }
    '/_flight/flights/checkout/': {
      id: '/_flight/flights/checkout/'
      path: '/flights/checkout'
      fullPath: '/flights/checkout'
      preLoaderRoute: typeof FlightFlightsCheckoutIndexRouteImport
      parentRoute: typeof FlightRouteRoute
    }
    '/_flight/flights/$flightId/': {
      id: '/_flight/flights/$flightId/'
      path: '/flights/$flightId'
      fullPath: '/flights/$flightId'
      preLoaderRoute: typeof FlightFlightsFlightIdIndexRouteImport
      parentRoute: typeof FlightRouteRoute
    }
    '/_account/orders/$orderId/': {
      id: '/_account/orders/$orderId/'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AccountOrdersOrderIdIndexRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/_account/order/$orderId/': {
      id: '/_account/order/$orderId/'
      path: '/order/$orderId'
      fullPath: '/order/$orderId'
      preLoaderRoute: typeof AccountOrderOrderIdIndexRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/_account/food-orders/$foodOrderId/': {
      id: '/_account/food-orders/$foodOrderId/'
      path: '/food-orders/$foodOrderId'
      fullPath: '/food-orders/$foodOrderId'
      preLoaderRoute: typeof AccountFoodOrdersFoodOrderIdIndexRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/_account/flight-bookings/$bookingId/': {
      id: '/_account/flight-bookings/$bookingId/'
      path: '/flight-bookings/$bookingId'
      fullPath: '/flight-bookings/$bookingId'
      preLoaderRoute: typeof AccountFlightBookingsBookingIdIndexRouteImport
      parentRoute: typeof AccountRouteRoute
    }
    '/_food-grubhub/food/payment/success': {
      id: '/_food-grubhub/food/payment/success'
      path: '/food/payment/success'
      fullPath: '/food/payment/success'
      preLoaderRoute: typeof FoodGrubhubFoodPaymentSuccessRouteImport
      parentRoute: typeof FoodGrubhubRouteRoute
    }
    '/_food-grubhub/restaurant/$restaurantId/menuItem/$menuItemId/': {
      id: '/_food-grubhub/restaurant/$restaurantId/menuItem/$menuItemId/'
      path: '/restaurant/$restaurantId/menuItem/$menuItemId'
      fullPath: '/restaurant/$restaurantId/menuItem/$menuItemId'
      preLoaderRoute: typeof FoodGrubhubRestaurantRestaurantIdMenuItemMenuItemIdIndexRouteImport
      parentRoute: typeof FoodGrubhubRouteRoute
    }
  }
}

interface AccountRouteRouteChildren {
  AccountAddressesIndexRouteRoute: typeof AccountAddressesIndexRouteRoute
  AccountFlightBookingsIndexRoute: typeof AccountFlightBookingsIndexRoute
  AccountFoodOrdersIndexRoute: typeof AccountFoodOrdersIndexRoute
  AccountOrderIndexRoute: typeof AccountOrderIndexRoute
  AccountOrdersIndexRoute: typeof AccountOrdersIndexRoute
  AccountProfileIndexRoute: typeof AccountProfileIndexRoute
  AccountRewardsIndexRoute: typeof AccountRewardsIndexRoute
  AccountFlightBookingsBookingIdIndexRoute: typeof AccountFlightBookingsBookingIdIndexRoute
  AccountFoodOrdersFoodOrderIdIndexRoute: typeof AccountFoodOrdersFoodOrderIdIndexRoute
  AccountOrderOrderIdIndexRoute: typeof AccountOrderOrderIdIndexRoute
  AccountOrdersOrderIdIndexRoute: typeof AccountOrdersOrderIdIndexRoute
}

const AccountRouteRouteChildren: AccountRouteRouteChildren = {
  AccountAddressesIndexRouteRoute: AccountAddressesIndexRouteRoute,
  AccountFlightBookingsIndexRoute: AccountFlightBookingsIndexRoute,
  AccountFoodOrdersIndexRoute: AccountFoodOrdersIndexRoute,
  AccountOrderIndexRoute: AccountOrderIndexRoute,
  AccountOrdersIndexRoute: AccountOrdersIndexRoute,
  AccountProfileIndexRoute: AccountProfileIndexRoute,
  AccountRewardsIndexRoute: AccountRewardsIndexRoute,
  AccountFlightBookingsBookingIdIndexRoute:
    AccountFlightBookingsBookingIdIndexRoute,
  AccountFoodOrdersFoodOrderIdIndexRoute:
    AccountFoodOrdersFoodOrderIdIndexRoute,
  AccountOrderOrderIdIndexRoute: AccountOrderOrderIdIndexRoute,
  AccountOrdersOrderIdIndexRoute: AccountOrdersOrderIdIndexRoute,
}

const AccountRouteRouteWithChildren = AccountRouteRoute._addFileChildren(
  AccountRouteRouteChildren,
)

interface FlightRouteRouteChildren {
  FlightFlightsIndexRoute: typeof FlightFlightsIndexRoute
  FlightFlightsFlightIdIndexRoute: typeof FlightFlightsFlightIdIndexRoute
  FlightFlightsCheckoutIndexRoute: typeof FlightFlightsCheckoutIndexRoute
}

const FlightRouteRouteChildren: FlightRouteRouteChildren = {
  FlightFlightsIndexRoute: FlightFlightsIndexRoute,
  FlightFlightsFlightIdIndexRoute: FlightFlightsFlightIdIndexRoute,
  FlightFlightsCheckoutIndexRoute: FlightFlightsCheckoutIndexRoute,
}

const FlightRouteRouteWithChildren = FlightRouteRoute._addFileChildren(
  FlightRouteRouteChildren,
)

interface FoodGrubhubRouteRouteChildren {
  FoodGrubhubFoodCartRoute: typeof FoodGrubhubFoodCartRoute
  FoodGrubhubFoodIndexRoute: typeof FoodGrubhubFoodIndexRoute
  FoodGrubhubFoodPaymentSuccessRoute: typeof FoodGrubhubFoodPaymentSuccessRoute
  FoodGrubhubFoodPaymentIndexRoute: typeof FoodGrubhubFoodPaymentIndexRoute
  FoodGrubhubRestaurantRestaurantIdIndexRoute: typeof FoodGrubhubRestaurantRestaurantIdIndexRoute
  FoodGrubhubRestaurantRestaurantIdMenuItemMenuItemIdIndexRoute: typeof FoodGrubhubRestaurantRestaurantIdMenuItemMenuItemIdIndexRoute
}

const FoodGrubhubRouteRouteChildren: FoodGrubhubRouteRouteChildren = {
  FoodGrubhubFoodCartRoute: FoodGrubhubFoodCartRoute,
  FoodGrubhubFoodIndexRoute: FoodGrubhubFoodIndexRoute,
  FoodGrubhubFoodPaymentSuccessRoute: FoodGrubhubFoodPaymentSuccessRoute,
  FoodGrubhubFoodPaymentIndexRoute: FoodGrubhubFoodPaymentIndexRoute,
  FoodGrubhubRestaurantRestaurantIdIndexRoute:
    FoodGrubhubRestaurantRestaurantIdIndexRoute,
  FoodGrubhubRestaurantRestaurantIdMenuItemMenuItemIdIndexRoute:
    FoodGrubhubRestaurantRestaurantIdMenuItemMenuItemIdIndexRoute,
}

const FoodGrubhubRouteRouteWithChildren =
  FoodGrubhubRouteRoute._addFileChildren(FoodGrubhubRouteRouteChildren)

interface ShopRouteRouteChildren {
  ShopCartIndexRoute: typeof ShopCartIndexRoute
  ShopChristmasSalesIndexRoute: typeof ShopChristmasSalesIndexRoute
  ShopFlashDealsIndexRoute: typeof ShopFlashDealsIndexRoute
  ShopPaymentIndexRoute: typeof ShopPaymentIndexRoute
  ShopShopIndexRoute: typeof ShopShopIndexRoute
  ShopCheckoutResultIndexRoute: typeof ShopCheckoutResultIndexRoute
  ShopProductProductIdIndexRoute: typeof ShopProductProductIdIndexRoute
}

const ShopRouteRouteChildren: ShopRouteRouteChildren = {
  ShopCartIndexRoute: ShopCartIndexRoute,
  ShopChristmasSalesIndexRoute: ShopChristmasSalesIndexRoute,
  ShopFlashDealsIndexRoute: ShopFlashDealsIndexRoute,
  ShopPaymentIndexRoute: ShopPaymentIndexRoute,
  ShopShopIndexRoute: ShopShopIndexRoute,
  ShopCheckoutResultIndexRoute: ShopCheckoutResultIndexRoute,
  ShopProductProductIdIndexRoute: ShopProductProductIdIndexRoute,
}

const ShopRouteRouteWithChildren = ShopRouteRoute._addFileChildren(
  ShopRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRouteRoute: AccountRouteRouteWithChildren,
  FlightRouteRoute: FlightRouteRouteWithChildren,
  FoodGrubhubRouteRoute: FoodGrubhubRouteRouteWithChildren,
  ShopRouteRoute: ShopRouteRouteWithChildren,
  AboutUsRoute: AboutUsRoute,
  BookmarkRoute: BookmarkRoute,
  BookmarksRoute: BookmarksRoute,
  BusinessRoute: BusinessRoute,
  CleanUpRoute: CleanUpRoute,
  ContactUsRoute: ContactUsRoute,
  PricingRoute: PricingRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  RReferralIdRoute: RReferralIdRoute,
  ChatIndexRoute: ChatIndexRoute,
  StoresIndexRoute: StoresIndexRoute,
  AuthSignInWithGoogleIdTokenRoute: AuthSignInWithGoogleIdTokenRoute,
  INTERNALMenuIndexRoute: INTERNALMenuIndexRoute,
  StoresStoreIdIndexRoute: StoresStoreIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
